module.exports = __webpack_public_path__ + "static/media/Linktree.0af43355.png";